import { render, staticRenderFns } from "./WaitingCredentialsCard.vue?vue&type=template&id=4f9502cb&scoped=true&"
import script from "./WaitingCredentialsCard.vue?vue&type=script&lang=js&"
export * from "./WaitingCredentialsCard.vue?vue&type=script&lang=js&"
import style0 from "./WaitingCredentialsCard.vue?vue&type=style&index=0&id=4f9502cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9502cb",
  null
  
)

export default component.exports